export function lockButton(button) {
	$(button).prop("disabled", true)
  fullscreenLoader.show()
}

export function unlockButton(button) {
	$(button).prop("disabled", false)
  fullscreenLoader.hide()
}

// Closes #mainModal without taking the loader with it. The modal's hidden.bs.modal handler in
// application.js hides the loader as part of resetting the modal, which for a flow that closes the
// modal and then waits on a job blanked the screen for the whole wait (TODO-ARCHIVE.md F-42). The
// handler reads and clears the flag, so it covers exactly this one close; the loader is then
// unlockButton's to release.
export function hideModalKeepLoader() {
  if (!$('#mainModal').hasClass('show')) return
  window.keepLoaderOnModalClose = true
  mainModal.hide()
}